module.exports = __webpack_public_path__ + "cy.svg?482a63747c778db23de75fcae44e22e9";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/cy.svg
// module id = 788
// module chunks = 27